import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { defaultStoreDTO } from '@utils/store';

import { TDefaultStoreDTO } from '@interfaces/common/store';

import { defaultMeta } from '@enums/common';

interface IInitialState extends TDefaultStoreDTO {
	assetOwnerId: string | null;
	assetType: string | null;
}

const initialState: IInitialState = {
	...defaultMeta,
	sortDirection: false,
	sortFieldName: null,
	searchValue: '',
	assetOwnerId: null,
	assetType: null,
};

const assetCartRequestAvailableList = createSlice({
	name: 'assetCartRequestAvailableList',
	initialState,
	reducers: {
		...defaultStoreDTO,
		setAssetOwnerId: (state, action: PayloadAction<{ assetOwnerId: string | null }>) => {
			state.assetOwnerId = action.payload.assetOwnerId;
			state.page = initialState.page;
		},
		setAssetType: (state, action: PayloadAction<{ assetType: string | null }>) => {
			state.assetType = action.payload.assetType;
			state.page = initialState.page;
		},
		resetAssetCartRequestTable: () => initialState,
	},
});

export const {
	setPage,
	setPageSize,
	setSort,
	setSearchValue,
	setAssetOwnerId,
	setAssetType,
} = assetCartRequestAvailableList.actions;

export default assetCartRequestAvailableList.reducer;
